function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { chakra, useStyles } from '@chakra-ui/system';
import React from 'react';
import { CaretLeftIcon, CaretRightIcon, EllipsisIcon } from '../icons';
import { usePaginationContext } from '../pagination';
import { PageSelect } from './page-select';
export var PageNavigator = props => {
  var pageCxt = usePaginationContext();
  var styles = useStyles();

  var handlePageChange = value => () => {
    pageCxt.onPageChange(value);
  };

  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    __css: styles.navigator
  }, props), /*#__PURE__*/React.createElement(CaretLeftIcon, _extends({
    color: "gray.900"
  }, pageCxt.prevDisabled && {
    pointerEvents: 'none',
    color: 'gray.400'
  }, {
    onClick: handlePageChange(pageCxt.pageNumber - 1)
  })), /*#__PURE__*/React.createElement(chakra.nav, null, pageCxt.pageRange.map(PAGE => {
    if (Array.isArray(PAGE)) {
      return /*#__PURE__*/React.createElement(chakra.div, {
        key: PAGE + "-Place"
      }, /*#__PURE__*/React.createElement(EllipsisIcon, {
        color: "gray.900",
        fontSize: "1.2em"
      }), /*#__PURE__*/React.createElement(PageSelect, {
        containerProps: {
          zIndex: 100,
          opacity: 0,
          position: 'absolute',
          top: 0,
          left: 0
        },
        options: PAGE.map(SIZE => ({
          label: SIZE,
          value: SIZE
        })),
        selectProps: {
          value: String(pageCxt.pageSize),
          onChange: _ref => {
            var {
              target
            } = _ref;
            return handlePageChange(Number(target.value) - 1)();
          }
        }
      }));
    }

    return /*#__PURE__*/React.createElement(chakra.button, _extends({
      color: "gray.900",
      key: PAGE + "-Place",
      onClick: handlePageChange(PAGE - 1)
    }, PAGE === pageCxt.pageNumber + 1 && {
      background: 'fluidBlue',
      color: 'white'
    }), PAGE);
  })), /*#__PURE__*/React.createElement(CaretRightIcon, _extends({
    color: "gray.900"
  }, pageCxt.nextDisabled && {
    pointerEvents: 'none',
    color: 'gray.400'
  }, {
    onClick: handlePageChange(pageCxt.pageNumber + 1)
  })));
};
//# sourceMappingURL=page-navigator.js.map